import React, { useState } from 'react';
import {
  Button,
  IconButton,
  Box,
  Typography,
  Grid,
  Toolbar,
  Divider,
  Paper,
  Stack,
  CircularProgress,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { createProvider, updateProvider } from '../../../../actions/providers';
import PROVIDER_TYPES from '../../providerTypes';
// import PaymentModeField from '../Shared/PaymentModeField';
import GCPCredentialsField from './GCPCredentialsField';
import { getResourcesDashboardPath } from '@/util/routePaths';

const provider_type = PROVIDER_TYPES.GCP;

export default function GCPProviderProviderForm({ provider }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [pristine, setPristine] = useState(true);
  const [payment_mode] = useState(provider?.payment_mode || 'credits');
  const [credentials, setCredentials] = useState(provider?.credentials || {});
  const [credentials_error, setCredentialsError] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      if (provider) {
        await dispatch(
          updateProvider(provider.provider_uuid, { payment_mode, credentials })
        );
      } else {
        await dispatch(
          createProvider({
            type: provider_type.value,
            payment_mode,
            credentials,
          })
        );
      }
      navigate('/resources');
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Paper sx={{ display: 'flex', width: '100%' }}>
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <Paper sx={{ display: 'flex', width: '100%' }} elevation={2}>
            <Toolbar>
              <Stack spacing={2} direction='row' alignItems='center'>
                <IconButton onClick={() => navigate(getResourcesDashboardPath())} disabled={loading}>
                  <ArrowBack />
                </IconButton>
                <Typography variant='h5'>{provider_type?.label}</Typography>
              </Stack>
            </Toolbar>
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <Box padding='15px' sx={{ maxWidth: 400 }}>
            <Grid container spacing={2} sx={{ flexGrow: 1 }}>
              {/* <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                <Typography variant='h6'>General</Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                <PaymentModeField
                  value={payment_mode}
                  setValue={setPaymentMode}
                  setChanged={() => setPristine(false)}
                />
              </Grid> */}

              <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                <GCPCredentialsField
                  value={credentials}
                  setValue={setCredentials}
                  setError={setCredentialsError}
                  setChanged={() => setPristine(false)}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <Divider />
          <Toolbar>
            <Stack spacing={2} direction='row'>
              <Button
                variant='contained'
                color='brand'
                onClick={handleSubmit}
                disabled={credentials_error || pristine || loading}
                startIcon={loading ? <CircularProgress size={20} /> : undefined}
              >
                Submit
              </Button>

              <Button
                variant='outlined'
                onClick={() => navigate(getResourcesDashboardPath())}
                disabled={loading}
              >
                Cancel
              </Button>
            </Stack>
          </Toolbar>
        </Grid>
      </Grid>
    </Paper>
  );
}
